// import envFile from './env.json';
const envVar = import.meta.env;
const envFile = JSON.parse(envVar['VITE_APP_ENV_VARIABLE']);

export const APP_ID = envFile.APP_ID;

/** DatadogのアプリケーションID（公開値） */
export const DD_APPLICATION_ID = envFile.DD_APPLICATION_ID;
/** Datadogクライアントトークン（RUMとLogsで共用、公開値） */
export const DD_CLIENT_TOKEN = envFile.DD_CLIENT_TOKEN;
/** Datadogのインテークサイト（例: ap1.datadoghq.com） */
export const DD_SITE = envFile.DD_SITE ?? 'ap1.datadoghq.com';
/** Datadogに表示されるサービス名 */
export const DD_SERVICE = envFile.DD_SERVICE ?? 'r05-ticket-web-app';
/** 環境タグ（例: production / staging / dev） */
export const DD_ENV = envFile.DD_ENV;

// 言語のキーとタイトルの定義
export const LANGUAGES = [
    {
        title: '日本語',
        subTitle: '日本語',
        key: 'ja',
        fontFamily: 'NotoSansJP',
    },
    {
        title: 'English',
        subTitle: '英語',
        key: 'en',
        fontFamily: 'NotoSans',
    },
    {
        title: '繁體中文',
        subTitle: '中国語 (繁体字)',
        key: 'zh-TW',
        fontFamily: 'NotoSansTC',
    },
    {
        title: '简体中文',
        subTitle: '中国語 (簡体字)',
        key: 'zh',
        fontFamily: 'NotoSansSC',
    },
    {
        title: '한국어',
        subTitle: '韓国語',
        key: 'ko',
        fontFamily: 'NotoSansKR',
    },
    {
        title: 'Tiếng Việt',
        subTitle: 'ベトナム語',
        key: 'vi',
        fontFamily: 'NotoSans',
    },
    {
        title: 'ภาษาไทย',
        subTitle: 'タイ語',
        key: 'th',
        fontFamily: 'NotoSans',
    },
    {
        title: 'Indonesia',
        subTitle: 'インドネシア語',
        key: 'id',
        fontFamily: 'NotoSans',
    },
];

// footerを表示するフラグ
export const ROOT_PATHNAME = [
    '/',
    '/buy',
    '/buy/', //外部IDでサインアウト時にスプラッシュ画面を介さずにフラグ
    '/buy/ticket/success',
    '/bought',
    '/profile',
    '/bought/detail',
    '/bought/used',
    '/bought/refund',
    '/buy/ticket',
    '/buy',
    '/profile/licenses',
    '/buy/group-ticket',
    '/buy/reservation',
    '/buy/ticket/credit-certificate',
    '/buy/reservation/calendar',
    '/buy/reservation/user-info',
    '/buy/reservation/confirm',
    '/buy/reservation/section',
    '/buy/vouchers',
];

export const APP_VERSION = '1.6.1';

export const BUILD_VERSION = (import.meta.env.VITE_BUILD_VERSION as string | undefined) ?? '';

export const SHOW_BUILD_VERSION = (envFile.SHOW_BUILD_VERSION as boolean | undefined) ?? false;

export const DISPLAY_VERSION = SHOW_BUILD_VERSION && BUILD_VERSION ? `${APP_VERSION}-${BUILD_VERSION}` : APP_VERSION;

//「見本」を表示フラグ
// IS_PRODUCTIONが確実にtrueである場合にのみ表示しない。
export const DEV_ENV_FLAG = !(envFile.IS_PRODUCTION === true);

// 戻るボタンを表示しないフラグ
export const BTN_BACK_HIDDEN = ['/', '/buy', 'bought/ticket', '/bought', '/profile', '/buy/ticket/success'];

export const DURATION_TURN_OFF_DIALOG = 5;

//チャットボトのURL
export const CHATBOT_URL = envFile.CHATBOT_URL ?? 'https://app.chatplus.jp/chat/visitor/3c5fa5fa_3?t=btn';

//メールアドレスサポート
export const MAIL_SUPPORT = 'support@quickride.jp';

//Phoneサポート
export const PHONE_SUPPORT = '058-324-3123';

//QUICK TRIPホームページへの各リンク値
// デフォルト値はsrc/api/data-dummy/default-home-urls.jsonの値
// src/hooks/useHomeUrls.jsで、上記ファイルのデフォルト値を環境変数で指定した値(下記)で上書きしている
export const HOME_URL = envFile.HOME_URL ?? {};

export const R05_API_CONFIG = {
    baseUrl: envFile.R05_API_URL,
    API_KEY: envFile.R05_API_KEY,
};

export const GMO_SHOP_ID = envFile.GMO_SHOP_ID;

export const APPLE_MERCHANT_IDENTIFIER = envFile.APPLE_MERCHANT_IDENTIFIER;

export const GOOGLE_MERCHANT_IDENTIFIER = envFile.GOOGLE_MERCHANT_IDENTIFIER;

export const GOOGLE_PAYMENT_ENVIRONMENT = envFile.IS_PRODUCTION ? 'PRODUCTION' : 'TEST';

export const ATTENTION_COLOR = '#FF2AFF';

/**
 * inputの数量
 */
export const OTP_INPUT_AMOUNT = 6;

export const ORDER_STATUS = {
    BOUGHT: 'bought',
    NORMAL_PENDING: 'normalRefundPending',
    WEB_PENDING: 'webRefundPending',
    NORMAL_REFUND: 'normalRefunded',
    WEB_REFUND: 'webRefunded',
    PENDING: 'pending',
    FAILED: 'failed',
    USER_REFUND_ENABLED: 'userRefundEnabled',
    STOCK_USER_REFUND_ENABLED: 'stockUserRefundEnabled',
    USER_REFUND_PENDING: 'userRefundPending',
    STOCK_USER_REFUND_PENDING: 'stockUserRefundPending',
    USER_REFUNDED: 'userRefunded',
    STOCK_USER_REFUNDED: 'stockUserRefunded',
};

export const TICKET_STATUS = {
    BOUGHT: 'bought',
    ACTIVATE_DEADLINE_PASSED: 'activateDeadlinePassed',
};

export const USAGE_TICKET_STATUS = {
    BOUGHT: 'bought',
    ACTIVATED: 'activated',
    EXPIRED: 'expired',
    USED: 'used',
    PARTIALLY_USED: 'partially_used',
};

export const TICKET_TYPE = {
    TICKET: 'ticket',
    COUPON: 'coupon',
};

export const REFUND_STATUS = {
    NORMAL_PENDING: 'normal_refund_pending',
    WEB_PENDING: 'web_refund_pending',
    NORMAL_SUCCESS: 'normal_refund_success',
    WEB_SUCCESS: 'web_refund_success',
    NORMAL_FAILED: 'normal_refund_failed',
    WEB_FAILED: 'web_refund_failed',
};

// チケット購入処理のlocalStorage keyとして扱う。
export const TICKET_INFO_DATA = 'ticket-info-data'; // 購入中のチケット情報
export const IS_IN_PURCHASE = 'is-in-purchase'; // 購入中であるかどうかのフラグ
export const localStorageKeys = {
    TICKET_INFO_DATA: 'ticket-info-data',
    IS_IN_PURCHASE: 'is-in-purchase',
    USER_INFO_FORM: 'user-form-info',
    RESERVATION_INFO_DATA: 'reservation-info-data',
    FORM_VALUE_WITH_USER: 'form-value-with-user',
    ANONYMOUS_FORM_ANSWERS: 'anonymous-form-answers',
    LOGIN_FLOW: 'login-flow',
    RECEIVE_INFO: 'receive-info',
    RESERVATION_FLOW: 'reservation-flow',
};

// デフォルトのチケット表示

export const defaultThemes = {
    backgroundColor1: '#000000',
    colorFontTicket1Top: '#FFFFFF',
    colorFontTicket1Center: '#FFFFFF',
    colorFontTicket1Bottom: '#FFFFFF',
    backgroundColor2: '#ffffff',
    colorFontTicket2Top: '#000000',
    colorFontTicket2Center: '#000000',
    colorFontTicket2Bottom: '#000000',
};

export const PAYMENT_TYPE = {
    paypay: 'PAYPAY',
    applePay: 'APPLE_PAY_TOKEN',
    googlePay: 'GOOGLE_PAY_TOKEN',
    creditCard: 'MP_TOKEN',
};

export const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const SECRET_MANAGER_NAME = envFile.SECRET_MANAGER_NAME;

export const TIMEOUT_DURATION = 20 * 1000; // 20秒

export const ONLINE_FETCH_TIMEOUT = 15 * 1000; // 15秒

export const USING_PERIOD_UNIT = {
    MINUTE: 'm',
    DAY: 'D',
};

export const TICKET_OPERATION_SCENARIOS = {
    NORMAL: 0,
    DISPLAY_QR_CODE: 1,
    SPOT_CODE: 2,
    RESERVATION: 3,
};

export const DEVICE_ID_KEY = 'QT_DEVICE_ID';

export const RELOAD_ON_VISIBILITY_PATHS = ['/bought/code'];

export const GMO_PG_URL = envFile.IS_PRODUCTION
    ? 'https://static.mul-pay.jp/ext/js/token.js'
    : 'https://stg.static.mul-pay.jp/ext/js/token.js';

export const PAYPAY_POOLING = {
    timeout: !isNaN(Number(envVar?.['VITE_APP_PAYPAY_POOLING_TIMEOUT']))
        ? Number(envVar?.['VITE_APP_PAYPAY_POOLING_TIMEOUT'])
        : 5000,
    retryCount: !isNaN(Number(envVar?.['VITE_APP_PAYPAY_POOLING_COUNT']))
        ? Number(envVar?.['VITE_APP_PAYPAY_POOLING_COUNT'])
        : 5,
};

export const PAYPAY_NATIVE_WEBVIEW_CONFIG = {
    fnAppBundleIdentifier: 'com.lecip.fnapp',
    fnAppCallbackUrl: 'com.lecip.fnapp://tickets/paypay-check',
};

export const PRICE_TYPE = {
    FIXED: 'fixed',
    ADDITION: 'addition',
    NO_COST: 'no_cost',
};

export const RESERVATION_STATUS = {
    PENDING: 'pending',
    CANCELED: 'canceled',
    RESERVED: 'reserved',
    APPROVED: 'approved',
    PAYMENT_EXPIRED: 'payment_expired',
    PAYMENT_CANCELED: 'payment_canceled',
};

export const RESERVATION_AVAILABLE_UNIT = {
    DAYS: 'days',
    MONTHS_WITH_DAY: 'months_with_day',
    MONTHS_WITHOUT_DAY: 'months_without_day',
};

export const SECTION_TYPE = {
    SINGLE: 'single',
    MULTI: 'multi',
    AREA: 'area',
};

export const SALE_TYPES = {
    APP: 'app',
    COUNTER: 'counter',
    API: 'api',
};

export const PRIVATE_RELAY_EMAIL = '@privaterelay.appleid.com';

export const NO_ADDRESS_EMAIL = '+noaddress';

/**
 * 在庫の状態
 */
export const STOCK_SALE_STATUS = {
    soldOut: 'sold_out',
    suspended: 'suspended',
    notStartSale: 'not_start_sale',
    deadlinePassed: 'deadline_passed',
    onSale: 'on_sale',
};

export const VOUCHER_TYPE = {
    FIXED_FIRST: 'fixed_first',
    NONE: 'none',
    ONE_TIME_FIRST: 'one_time_first',
};

export const QR_TYPE = {
    DISABLE: 'disable',
    SINGLE_SCAN: 'single_scan',
};

export const DISTRIBUTION_TYPE = {
    DISABLED: 'disabled',
    ENABLE: 'enabled',
    REQUIRED: 'required',
};

export const RESERVATION_CHANGE_TYPE = {
    DISABLE: 'disable ',
    NO_PRICE_CHANGE: 'no_price_change',
};

export const APPLE_STORE_URL = envFile.APPLE_STORE_URL;

export const GOOGLE_PLAY_URL = envFile.GOOGLE_PLAY_URL;

export const APP_URL_SCHEME = envFile.APP_URL_SCHEME;

/**
 * 分配残数情報
 */
export const REMAINING_ORDER_DISTRIBUTION_STATUS = {
    BOUGHT: 'bought',
    ALL_DISTRIBUTED: 'all_distributed',
    USED: 'used',
};

//「ホーム」リンク
export const HOME_PAGE_URL = envFile.HOME_PAGE_URL;

//受け取るの有効期間
export const EXPIRATION_RECEIVE_TIME = 24; //時間

//分配状況
export const DISTRIBUTION_STATUS = {
    RECEIVED: 'received',
    USED: 'used',
    SEPARATED: 'separated',
};

// ソーシャルログインに対応するかどうかのフラグ
export const DISABLE_SOCIAL_LOGIN = envFile.DISABLE_SOCIAL_LOGIN;
